
<app-bread-crumb [items]="[{text:'pedidos'}]" [sectionTitle]="'Lista de Pedidos'"></app-bread-crumb>

<section class="content">
  <div class="row">
    <div class="col-md-12">
      <!-- inicio do box -->
      <ng-box [boxIcon]="'fa fa-shopping-cart'" [boxTitle]="'Pedidos'">

        <!-- conteudo do box -->
        <ng-container class="ng-box-content">

          <ng-table  [tableHeaderAndFooterColumns]="tableProprieties()" *ngIf="!isSpinnerLoading">

                <tr *ngFor="let order of objects;index" ngChangeColorOnHover>

                  <td>
                    {{order?.transaction}}
                  </td>

                  <td>
                    <span style="font-size:medium;color:#f35309">{{order?.member?.name}}</span>
                  </td>

                  <td *ngIf="isAdminOrUserKhuzela()">{{order?.club?.name}}</td>

                  <td>{{order?.amount | currency:'MZN':'symbol'}}</td>



                  <td>{{order?.created_at}}</td>
                  <td>{{order?.in_process_date | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                  <td>{{order?.sent_date | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                  <td>{{order?.received_date | date:'dd/MM/yyyy HH:mm:ss'}}</td>

                  <td>
                    <span *ngIf="order.status=='completo'" class="label label-success">{{order.status}}</span>
                    <span *ngIf="order.status=='pendente'"  class="label label-danger">{{order.status}}</span>
                    <span *ngIf="order.status=='em processo'"  class="label label-warning">{{order.status}}</span>
                    <span *ngIf="order.status=='enviado'"  class="label label-info">{{order.status}}</span>
                    <span *ngIf="order.status=='recebido'"  class="label label-primary">{{order.status}}</span>
                  </td>
                  <ng-actions-table-bar>

                    <ng-button
                      *ngIf="order.status=='pendente'"
                      (click)="changeStatus(order)"
                      [button]="{faIconClass:'fa fa-check',color:'warning',name:'MARCAR COMO => EM PROCESSO'}"
                    ></ng-button>

                    <ng-button
                      *ngIf="order.status=='em processo'"
                      (click)="changeStatus(order)"
                      [button]="{faIconClass:'fa fa-check',color:'info',name:'MARCAR COMO => ENVIADO'}"
                    ></ng-button>

                    <ng-button
                      *ngIf="order.status=='recebido'"
                      (click)="changeStatus(order)"
                      [button]="{faIconClass:'fa fa-check',color:'success',name:'MARCAR COMO => COMPLETO'}"
                    ></ng-button>

                    <ng-button
                      title="Mais Detalhes"
                      (click)="detail(order)"
                      [button]="{faIconClass:'fa fa-eye',color:'danger'}"
                    ></ng-button>

                  </ng-actions-table-bar>

                </tr>

          </ng-table>
                    <!-- fim da tabela -->
                    <box-loading class="overlay" *ngIf="isSpinnerLoading"></box-loading>
        </ng-container>
 <!-- fim do conteudo -->
      </ng-box>
    </div>
  </div>
</section>
